import React, {useContext} from "react";
import {
    InputRowContainer,
    CustomerInputRowContainer,
    InputRowTitle,
    CustomerInputRowTitle
} from "./InputRow.styles";
import {Col} from "antd";
import {CreateDeliveryContext} from "../../CreateDeliveryRequest";

export const InputRow = ({title, content, extra, ...props}) => {
    const {isFromCustomerTheme} = useContext(CreateDeliveryContext);

    // Choose styles based on customer theme
    const ContainerComponent = isFromCustomerTheme ? CustomerInputRowContainer : InputRowContainer;
    const TitleComponent = isFromCustomerTheme ? CustomerInputRowTitle : InputRowTitle;

    return (
        <ContainerComponent {...props}>
            <Col span="8">
                <TitleComponent>{title}</TitleComponent>
                <Col>{extra}</Col>
            </Col>
            <Col span="16">{content}</Col>
        </ContainerComponent>
    );
};
